import script from "./EditIndividualBaseBusiness.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditIndividualBaseBusiness.vue?vue&type=script&lang=ts&setup=true"

import "./EditIndividualBaseBusiness.vue?vue&type=style&index=0&id=033b6cf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033b6cf5"]])

export default __exports__